import React, { Fragment, Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { gtm, clickCtaEvent } from '~/common/utils/tracking';

import Button from '../CommonButton';
import styles from './two-column.css';

@withRouter
@inject('modalStore')
@observer

export default class TwoColumn extends Component {
    handleVideoClick = (event) => {
        event.stopPropagation();
        this.props.modalStore.setModalOptions({
            isModalOpen: true,
            isModalClosable: true,
            childComponentString: 'videoModal',
            transparent: true,
            modalProps: {
                videoId: this.props.video
            }
        });
    }

    render() {
        const { header, copy, ctaText, ctaHref, imgSrc, imgAltText, listContent, video, videoThumbnail } = this.props;
        return (
            <div className={styles.wrapper}>
                <div className={styles.content}>
                    <h2 className={styles['content-header']}>
                        {header}
                    </h2>
                    <p className={styles['content-copy']}>
                        {copy}
                    </p>
                    {listContent && <ul className={styles['content-list']}>
                        {listContent.map((item, index) => (
                            <li className={styles['content-list-item']} key={index}>
                                {item}
                            </li>
                        ))}
                    </ul>}
                    {ctaHref &&
                        <Button
                            href={ctaHref}
                            modifier={styles.cta}
                            onClick={() => {
                                gtm(clickCtaEvent(ctaText, ctaHref, 'two column component'));
                            }}
                            target="_blank"
                        >
                            {ctaText}
                        </Button>
                    }
                </div>
                <div className={styles['img-container']}>
                    {imgSrc &&
                        <img
                            alt={imgAltText} className={styles.img}
                            src={imgSrc}
                        >
                        </img>
                    }
                    {video &&
                        <Fragment>
                            <svg
                                className={styles['play-icon']}
                                height="58" onClick={this.handleVideoClick}
                                viewBox="0 0 58 58" width="58"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g fill="none">
                                    <circle
                                        className={styles['play-icon-circle']}
                                        cx="28.8" cy="28.8"
                                        fill="#AAA" r="28.8"
                                    >
                                    </circle>
                                    <polygon
                                        points="20 40 20 17.5 42.5 28.8"
                                    >
                                    </polygon>
                                    <rect
                                        height="60" width="60"
                                        x="-1" y="-1"
                                    ></rect>
                                </g>
                            </svg>

                            <img
                                alt='GH video'
                                className={`${styles.img} ${styles['video-thumbnail']}`}
                                onClick={this.handleVideoClick}
                                src={videoThumbnail}
                            />
                        </Fragment>
                    }
                </div>
            </div>
        );
    }
}
